import { combineReducers } from 'redux';

import grid from './grid/reducer';
import studentLookup from './studentlookup/reducer';
import duplicateApps from './duplicateapps/reducer';

export default combineReducers({
  grid,
  studentLookup,
  duplicateApps,
});



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/state/reducer.js